import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetEcshopTradesService } from "@/features/accounts/ecshop/services/get-trades-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetEcshopTradesResponseModel } from "@/features/accounts/ecshop/services/get-trades-model";


export const useGetEcshopTrades = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getEcshopTradesService = new GetEcshopTradesService();

  // その他連携明細一覧取得
  const getEcshopTrades = async (
    accountGroupId: string,
    ecshopAccountId: string,
    ecshopId: string,
    startDate?: string,
    endDate?: string,
  ) :Promise<GetEcshopTradesResponseModel[]> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getEcshopTradesService.getEcshopTrades({
        account_group_id:  accountGroupId,
        ecshop_account_id: ecshopAccountId,
        ecshop_id: ecshopId,
        ...(startDate !== undefined && { start_date: startDate }),
        ...(endDate !== undefined && { end_date: endDate }),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getEcshopTrades:", error);
      throw error;
      // return [];
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getEcshopTrades: errorHandledAsync(getEcshopTrades, setError),
  };
};
